<template>
  <div>
    <input
      type="text"
      class="for-popup input_full-width"
      v-model="$data[calendarId === 1 ? 'arrivalDate' : (calendarId === 2 ? 'storageDateFrom' : (calendarId === 3 ? 'storageDateEnd' : ''))]"
      @:change="info"
      :placeholder="placeholder"
      :id="`datepicker-${calendarId}`"
      autocomplete="off"
      readonly
      required
      :disabled="disabled"
    ><br>
    <small v-bind:class="`small-${calendarId}`" style="display: none">{{ this.validateDateText }}</small><br>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import $ from 'jquery'
import bookingDateValidation from '@/mixins/bookingDateValidation'
const { normalizeBookingDate } = require('@/utils/bookingDate')

export default {
  name: 'Calendar',
  props: ['calendarId', 'placeholder', 'minDate', 'disabled'],
  mixins: [bookingDateValidation],
  computed: {
    ...mapGetters(['getOrderInfo', 'getStorageInfo', 'getDayLess', 'getUrlPrices']),
    $route () {
      return this.$root.$route;
    }
  },
  data () {
    return {
      arrivalDate: '',
      storageDateFrom: '',
      storageDateEnd: '',
      validateDateText: 'Please, enter date only yyyy-mm-dd format',
      disabledDates:
        [
          '2025-12-24',
          '2025-12-25',
          '2025-12-31',
          '2026-01-01',
          '2026-12-24',
          '2026-12-25',
          '2026-12-31',
          '2027-01-01'
        ],
      annuallyDisabledDates: [
        '12-24',
        '12-25',
        '12-31',
        '01-01'
      ],
      unselectableElements: []
    }
  },

  mounted () {
    if (this.calendarId === 1) {
      this.calendar(`#datepicker-${this.calendarId}`, 'getOrderInfo', 'arrivalDate')
    }

    if (this.calendarId === 2) {
      this.calendar(`#datepicker-${this.calendarId}`, 'getStorageInfo', 'storageDateFrom')
    }

    if (this.calendarId === 3) {
      this.calendar(`#datepicker-${this.calendarId}`, 'getStorageInfo', 'storageDateEnd')
    }
    this.calendar()
  },
  created () {
    if (this.getOrderInfo.arrivalDate) {
      this.arrivalDate = normalizeBookingDate(this.getOrderInfo.arrivalDate)
    }

    if (this.getStorageInfo.storageDateFrom) {
      this.storageDateFrom = normalizeBookingDate(this.getStorageInfo.storageDateFrom)
    }

    if (this.getStorageInfo.storageDateEnd) {
      this.storageDateEnd = normalizeBookingDate(this.getStorageInfo.storageDateEnd)
    }
  },
  beforeDestroy () {
    this.unselectableElements.forEach(element => {
      element.removeEventListener('click', this.handleClickDisabledDate)
    })
    this.unselectableElements = []
  },
  methods: {
    ...mapMutations(['addDate', 'validator']),
    calendar (datepicker, storage, destination) {
      const VM = this
      $(datepicker).datepicker({
        dateFormat: 'yy-mm-dd',
        minDate: datepicker === '#datepicker-3' ? this.minDate : this.getmindate(), // First available date
        beforeShow: function () {
          return {
            minDate: datepicker === '#datepicker-3' ? VM.minDate : VM.getmindate()
          }
        },
        beforeShowDay: function (date) {
          const stringDate = $.datepicker.formatDate('yy-mm-dd', date)
          const stringMonthDay = stringDate.slice(5)
          const isDisabledDate = VM.disabledDates.includes(stringDate)
          const isAnnuallyDisabledDate = VM.annuallyDisabledDates.includes(stringMonthDay)
          return [!(isDisabledDate || isAnnuallyDisabledDate)]
        },
        onSelect: function (dateText) {
          this.date = dateText

          VM.addDate({
            [destination]: $(datepicker).val()
          })

          // console.log(VM[storage][destination])
          if (datepicker !== '#datepicker-3') {
            if (VM.getDayLess(dateText) && VM[storage][destination] !== '') {
              alert('Your arrival date is 2 days or less from now — late order fee will added')
            }
          }

          this[destination] = VM[storage][destination]
          VM.validateDate(dateText)
        },
        onUpdateDatepicker: () => {
          this.unselectableElements.forEach(element => {
            element.removeEventListener('click', this.handleClickDisabledDate)
          })

          this.unselectableElements = document.querySelectorAll('.ui-datepicker-calendar .ui-datepicker-unselectable.ui-state-disabled:not(.ui-datepicker-other-month)')
          this.unselectableElements.forEach(element => {
            element.addEventListener('click', this.handleClickDisabledDate)
          })
        }
      })
    },

    info () {
      if (this.calendarId === 1) this.validateDate(this.arrivalDate)
      if (this.calendarId === 2) this.validateDate(this.storageDateFrom)
      if (this.calendarId === 3) this.validateDate(this.storageDateEnd)

      if (this.calendarId === '1') {
        this.addDate({
          arrivalDate: $(`#datepicker-${this.calendarId}`).val()
        })
      }

      if (this.calendarId === '2') {
        this.addDate({
          storageDateFrom: $(`#datepicker-${this.calendarId}`).val()
        })
      }

      if (this.calendarId === '3') {
        this.addDate({
          storageDateEnd: $(`#datepicker-${this.calendarId}`).val()
        })
      }
    },
    validateDate (dataStr) {
      if (!(dataStr.match(/^\d{4}-\d{2}-\d{2}$/))) {
        $(`#datepicker-${this.calendarId}`).addClass('invalid')
        $(`.small-${this.calendarId}`).css('display', 'block')
        this.validator(dataStr)
      } else {
        $(`#datepicker-${this.calendarId}`).removeClass('invalid')
        $(`.small-${this.calendarId}`).css('display', 'none')
        this.validator(dataStr)
      }
    },
    getmindate () {
      return this.getCurrentMinimumBookingDate()
    },
    handleClickDisabledDate () {
      alert('Sorry, we are closed for bookings this day') // + Date())
    }
  },
  watch: {
    'getOrderInfo.arrivalDate' (date) {
      this.arrivalDate = normalizeBookingDate(date)
    },
    'getStorageInfo.storageDateFrom' (date) {
      this.storageDateFrom = normalizeBookingDate(date)
    },
    'getStorageInfo.storageDateEnd' (date) {
      this.storageDateEnd = normalizeBookingDate(date)
    },
    minDate () {
      $('#datepicker-3').datepicker('destroy')
      $('#datepicker-3').val('')
      this.getStorageInfo.storageDateEnd = ''
      this.calendar('#datepicker-3', 'getStorageInfo', 'storageDateEnd')
    }
  }
}
</script>

<style scoped lang="scss">
  input, select {
    width: 20em;
    height: 40px;
    line-height: 3em;
    border: 1px solid #cccccc;
    border-radius: 10px;
    box-shadow: 0px 1px 2px 1px #cccccc;
    text-align: center;
  }

  .invalid {
    border: 1px solid #ff0000;
  }

  small {
    display: block;
    margin-top: 0.4em;
    color: #ff0000;
  }
</style>
